var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQoutesImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 77,
    height: 77,
    viewBox: "0 0 77 77",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "fi_7350737",
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M15.1236 57.4412C11.9213 53.8824 10 50 10 43.5294C10 32.2059 18.0056 22.1765 29.2135 17L32.0955 21.2059C21.5281 27.0294 19.2865 34.4706 18.6461 39.3235C20.2472 38.3529 22.4888 38.0294 24.7303 38.3529C30.4944 39 34.9775 43.5294 34.9775 49.6765C34.9775 52.5882 33.6966 55.5 31.7753 57.7647C29.5337 60.0294 26.9719 61 23.7697 61C20.2472 61 17.0449 59.3824 15.1236 57.4412ZM47.1461 57.4412C43.9438 53.8824 42.0225 50 42.0225 43.5294C42.0225 32.2059 50.0281 22.1765 61.236 17L64.118 21.2059C53.5506 27.0294 51.309 34.4706 50.6685 39.3235C52.2697 38.3529 54.5112 38.0294 56.7528 38.3529C62.5169 39 67 43.5294 67 49.6765C67 52.5882 65.7191 55.5 63.7978 57.7647C61.8764 60.0294 58.9944 61 55.7921 61C52.2697 61 49.0674 59.3824 47.1461 57.4412Z",
    fill: "#2C83EC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQoutesImg);
export default __webpack_public_path__ + "static/media/qoutes_img.d4a516f32e633119e4f6a56fc8afe8fd.svg";
export { ForwardRef as ReactComponent };